import { Navigate, useLocation } from 'react-router-dom';
import { usePermissions } from './usePermissions';
import { canAccessPageByPerm, firstAccessiblePath } from '../../lib/permissions';

/**
 * Guard de rota por PERMISSÃO (RBAC Fase 2). Espelha o gating do backend
 * (@RequirePermission): consulta as permissões efetivas do usuário
 * (usePermissions → papel custom/base). URL digitada na mão numa página
 * sem permissão volta pra primeira página acessível. UX — o backend é a
 * verdade (403).
 */
export function RequireRole({
  path,
  children,
}: {
  /** Chave do PAGE_PERMISSION (ex.: '/configuracoes'). */
  path: string;
  children: React.ReactNode;
}) {
  const { can, isLoading } = usePermissions();
  const location = useLocation();

  // Enquanto resolve as permissões, não redireciona (evita flash/loop).
  if (isLoading) return null;

  if (!canAccessPageByPerm(can, path)) {
    const to = firstAccessiblePath(can);
    return (
      <Navigate
        to={to === path ? '/ajuda' : to}
        replace
        state={{ deniedFrom: location.pathname }}
      />
    );
  }
  return <>{children}</>;
}
